import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from 'material-ui/Button';
import SaveIcon from '@material-ui/icons/Save';

const SaveButton = (props) => (
  <div style={{ position: 'fixed', right: 10, bottom: 10 }}>
    <MuiButton
      variant="raised"
      size="small"
      color="primary"
      style={{ minWidth: 50, width: 50, height: 50, borderRadius: '50%', padding: 10 }}
      onClick={props.handleSave}
    >
      <SaveIcon style={{ fontSize: 25 }} />
    </MuiButton>
  </div>
);

SaveButton.propTypes = {
  handleSave: PropTypes.func.isRequired,
};

export default SaveButton;



// WEBPACK FOOTER //
// ./src/components/SaveButton.jsx